import { useLocation, useParams } from 'react-router-dom';
import { BackButton } from 'Components/molecules';
import { AgGridCustomActionExecutions } from 'Components/organisms';
import { ACTION_EXECUTIONS_PAGE_TITLE } from 'Core-utils/constants/constants';
import { ACTIONS_WORKFLOWS_ROUTE } from 'Core-utils/routes';
import '../EngagementFlowPage/styles.scss';
import './styles.scss';

type LocationState = {
  displayValue?: string;
};

const CustomActionExecutionsPage = () => {
  const { id: actionSpecId } = useParams();
  const location = useLocation();
  const state = (location.state as LocationState) ?? {};
  const actionTitle = state.displayValue?.trim() || actionSpecId || '—';

  if (!actionSpecId) {
    return null;
  }

  return (
    <div className="custom-action-executions-page">
      <div className="custom-action-executions-page__content d-flex flex-column gap-3 h-100">
        <BackButton navigateBack={ACTIONS_WORKFLOWS_ROUTE} />
        <AgGridCustomActionExecutions
          actionSpecId={actionSpecId}
          title={`${ACTION_EXECUTIONS_PAGE_TITLE}: ${actionTitle}`}
          tableBodyHeight="calc(100% - 2rem)"
          periodDays={30}
        />
      </div>
    </div>
  );
};

export default CustomActionExecutionsPage;
